import { Injectable } from "@angular/core";
import { verifyEmailPayload } from "src/app/modules/registration/models/CheckOtpModel";

@Injectable({ providedIn: "root" })
export class EmailVerifyMapper {
   
    registrationPayload(data:verifyEmailPayload){
    }
}